import React from "react";
import ContentFooter from "/react4xp/shared/ContentFooter/ContentFooter";

import type { ShowContentFooterProps } from "./type.d";

export default function ShowContentFooter(props: ShowContentFooterProps) {
  const { footerData } = props;

  return (
    <ContentFooter data={footerData} />
  );
}
